const state = {
    mobileShowMenu: true
  };
  const getters = {
    mobileSubMenuOpen: state => state.mobileShowMenu
  };
  const mutations = {
    toggleMobileSubMenu(state, bool) {
      state.mobileShowMenu = bool
    }
  };
  
  export default {
    state,
    getters,
    mutations
  };